

const cartProducts = (state, getters, rootState, rootGetters) => {
  return state.added.map((product) => {
    return product
  })
}
/*
const itemsQuantity = (state) => {
  return state.added.reduce((quantity, item) => {
    return quantity + item.quantity
  }, 0)
}
*/
const cartCount = (state) => {
  if (!state.added.length) {
    return 0
  }
  return state.added.reduce((quantity, next) => quantity + next.quantity, 0)
}

const cartSubTotal = (state) => {
  if (!state.added.length) {
    return 0
  }

  let subTotal = 0;
  for (let i = 0; i < state.added.length; i++) {
      subTotal += parseInt(state.added[i].quantity) * parseFloat(state.added[i].special_price ? state.added[i].special_price : state.added[i].price);
  }

  return Math.round(subTotal * 100) / 100;
}

const cartTotal = (state) => {
    if(cartDiscountAmount(state)) {
        let amountWithDiscount = parseFloat((cartSubTotal(state) - cartDiscountAmount(state)) + cartShipping(state)).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];

        return parseFloat(amountWithDiscount);
    } else {
        return cartSubTotal(state) + cartShipping(state)
    }
}

const cartShipping = (state) => {
  if (!state.added.length) {
    return 0
  }
  return state.added.reduce((quantity, next) => quantity + next.quantity * state.shipping, 0)
}


const cartDiscount = (state) => {
    return state.discount;
}
const cartDiscountAmount = (state) => {
    if(!state.discount.code || !state.discount.details.discount_type) return 0;

    let discount = 0;
    if(state.discount.details.discount_type === 'fixed') {
        discount = state.discount.details.discount_value;
    } else {
        discount = parseFloat(
                ((cartSubTotal(state) / 100) * state.discount.details.discount_value)
                .toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        );
    }

    if(discount > cartSubTotal(state)) {
        discount = cartSubTotal(state);
    }

    return discount;
}


/*
const subtotal = (state) => {
  const sum = state.added.reduce((subtotal, item) => {
    return subtotal + item.price * item.quantity
  }, 0)

  return state.productDiscount ? sum * 0.7 : sum
}

const taxes = (state) => {
  return getters.subtotal(state) * 0.005
}

const shipping = (state) => {
  if (state.freeShipping) {
    return 0
  } else {
    return 5.00
  }
}

const total = (state) => {
  const discout = state.totalDiscount ? -5 : 0
  return getters.subtotal(state) + getters.taxes(state) + getters.shipping(state) + discout
}
*/

export default {
  namespaced: true,
  state: {
    added: JSON.parse(sessionStorage.getItem('cart')) || [],
    open: false,
    // productDiscount: false,
    // totalDiscount: false,
    shipping: 0,
      discount: JSON.parse(sessionStorage.getItem('discount')) || {
        code: null,
          details: {
              id: null,
              discount_type: null,
              discount_value: null,
          }
      }
  },
  mutations: {
    TOGGLE (state, open) {
      state.open = open !== undefined ? open : !state.open
    },
    CLOSE (state) {
      state.open = false
    },
    SET_SHIPPING (state, data) {
      state.shipping = data
    },
    RETRIEVE_CART (state, data) {
      state.added = data
    },
    ADD_TO_CART (state, item) {
      console.log(item)
      const index = state.added.find(added => added.sku === item.sku)
      index ? (index.quantity = /*index.quantity +*/ item.quantity) : state.added.push(item)
    },
    ADD_ONE_TO_CART (state, item) {
      const index = state.added.find(added => added.sku === item)
      index ? index.quantity++ : state.added.push({
        sku: item,
        quantity: 1
      })
    },
    REMOVE_FROM_CART (state, item) {
      const index = state.added.findIndex(added => added.sku === item.sku)
      state.added.splice(index, 1)
    },
    CLEAR_CART (state, item) {
      state.added = []
    },
    REMOVE_ONE_FROM_CART (state, item) {
      const index = state.added.findIndex(added => added.sku === item.sku)
      state.added[index].quantity > 1
        ? state.added[index].quantity--
        : state.added.splice(index, 1)
    },
    SAVE (state) {
      sessionStorage.setItem('cart', JSON.stringify(state.added))
      sessionStorage.setItem('shipping', JSON.stringify(state.shipping))
      sessionStorage.setItem('discount', JSON.stringify(state.discount))
    },
      SET_DISCOUNT_CODE (state, discount) {
          state.discount.code = discount.code;
          state.discount.details.id = discount.details.id;
          state.discount.details.discount_type = discount.details.discount_type;
          state.discount.details.discount_value = discount.details.discount_value;
      },
      CLEAR_DISCOUNT (state) {
          state.discount.code = null;
          state.discount.details.id = null;
          state.discount.details.discount_type = null;
          state.discount.details.discount_value = null;
      },
  },
  getters: {
    cartOpen (state) {
      return state.open
    },
    cartProducts,
    cartCount,
    cartTotal,
    cartSubTotal,
    cartShipping,
    cartDiscount,
    cartDiscountAmount,
    // subtotal,
    // taxes,
    // shipping,
    // total
  },
  actions: {
    retrieveCart ({ commit }) {
        if (sessionStorage.getItem('cart') !== null) {
          const cartData = JSON.parse(sessionStorage.getItem('cart'))
          commit('RETRIEVE_CART', cartData)
        }
        if (sessionStorage.getItem('shipping') !== null) {
          const data = JSON.parse(sessionStorage.getItem('shipping'))
          commit('SET_SHIPPING', data)
        }
        if (sessionStorage.getItem('discount') !== null) {
          const data = JSON.parse(sessionStorage.getItem('discount'))
          commit('SET_DISCOUNT_CODE', data);
        }
    },
    addToCart ({ commit }, product) {
      if (product.stock !== 0) {
        commit('ADD_TO_CART', product)
        commit('SAVE')
        commit('TOGGLE')
      }
    },
    addOneToCart ({ commit }, product) {
      if (product.stock !== 0) {
        commit('ADD_ONE_TO_CART', product.sku)
        commit('SAVE')
      }
    },
    clear ({ commit }) {
      commit('CLEAR_CART')
      commit('SAVE')
    },
    remove ({ commit }, product) {
      commit('REMOVE_FROM_CART', product)
      commit('SAVE')
    },
    removeOne ({ commit }, product) {
      commit('REMOVE_ONE_FROM_CART', product)
      commit('SAVE')
    },
    setShipping ({ commit }, price) {
      commit('SET_SHIPPING', price)
      commit('SAVE')
    },
    setDiscountCode ({ commit }, discount) {
      commit('SET_DISCOUNT_CODE', discount);
      commit('SAVE')
    },
    clearDiscount ({ commit }) {
      commit('CLEAR_DISCOUNT')
      commit('SAVE')
    }
    /*
    toggleCoupon ({ commit }, coupon) {
      commit('TOGGLE_COUPON', coupon)
    }
    */
  }
}
